import { render, staticRenderFns } from "./RequestCreatorServicesGroup.vue?vue&type=template&id=8a013646&scoped=true&"
import script from "./RequestCreatorServicesGroup.vue?vue&type=script&lang=js&"
export * from "./RequestCreatorServicesGroup.vue?vue&type=script&lang=js&"
import style0 from "./RequestCreatorServicesGroup.vue?vue&type=style&index=0&id=8a013646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a013646",
  null
  
)

export default component.exports